import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import HrmOvertimeTable from "../../components/hrm/HrmOvertimeTable";
import { IOvertimeRequestQuery } from "../../models/Hrm";
import { useGetOvertimeRequestsByManager } from "../../query/HrmQuery";

const PersonalOvertimeApproval = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<IOvertimeRequestQuery>({
    page: 1,
    limit: 10,
  });
  const { data, isLoading } = useGetOvertimeRequestsByManager(filter);
  return (
    <>
      <Space className="px-4 pt-4">
        <Button
          type="default"
          size="large"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          className="w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600"
        >
          Quay lại
        </Button>
      </Space>
      <HrmOvertimeTable
        data={data!}
        isLoading={isLoading}
        filter={filter}
        isHasAvatars={true}
        setFilter={setFilter}
      />
    </>
  );
};

export default PersonalOvertimeApproval;
